module.exports = __webpack_public_path__ + "img/UZO-3.0ML.2c96302b.png";